

<div class="timeline">
    <div class="timeline-container">
        <div class="d-flex justify-content-between align-items-center">
            <mat-form-field class="date-input cursor-pointer pe-auto me-4" (click)="dp.open()">
                <input matInput class="cursor-pointer" [matDatepicker]="dp" [formControl]="date" (dateChange)="setDateFromCalendar($event.value, dp)" readonly (click)="dp.open()">
                <mat-datepicker #dp startView="multi-year"></mat-datepicker>
                <!-- <mat-datepicker #dp startView="multi-year" (monthSelected)="setMonthAndYear($event, dp)">
                </mat-datepicker> -->
            </mat-form-field>
            <!-- <span class="slider-value">{{ value }} / {{ monthDays }}</span> -->
            <mat-slider class="slider pe-auto" [max]="monthDays" [min]="1" [step]="1" [discrete]="true" [showTickMarks]="true"
                (change)="onSelectTimeline()">
                <input matSliderThumb [(ngModel)]="value" #slider>
            </mat-slider>
        </div>
    </div>
    
    <!-- <div class="d-flex flex-row">
        @for (number of [].constructor(30); track $index; let i = $index) {
        <div class="d-flex step-container flex-fill justify-content-center align-items-center position-relative" [class.step-container-active]="selectedIndex === i">
            <button class="example-step" [class.example-active]="selectedIndex === i" (click)="selectStepByIndex(i)">
                {{ i + 1}}
            </button>
        </div>
        }
    </div>   -->
</div>